import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { AppState } from "../store";
import type { SveaError } from "../types/error";

const initialState: SveaError = {
	errorMsg: undefined,
	statusCode: undefined,
	errorCode: undefined,
	stack: undefined,
};

const errorSlice = createSlice({
	name: "error",
	initialState,
	reducers: {
		setError: (_state, action: PayloadAction<SveaError>) => action.payload,
		resetError: () => initialState,
	},
});

export const selectError = (state: AppState) => state.error;

export const { setError, resetError } = errorSlice.actions;

export default errorSlice.reducer;
